<div class="card text-decoration-none bg-opacity-30">
  <div class="card-body d-flex align-items-center text m-5px text-truncate text-uppercase">
    <img #sourceImage id="selectedImage" [src]="activeImage.image" *ngIf="activeImage"/>
  </div>
  <div class="card-arrow">
    <div class="card-arrow-top-left"></div>
    <div class="card-arrow-top-right"></div>
    <div class="card-arrow-bottom-left"></div>
    <div class="card-arrow-bottom-right"></div>
  </div>
</div>